import { SasDeletePayload } from "@/types/interfaces/sasDeleteLink";
import { query, queryWithVariables } from "./api";

export const getSasUrlForDomainLogoUpload = async (): Promise<SasPayload> => {
    const getSasUrlForDomainLogoUpload = await query(
        `
        query DomainLogoUploadSas {
          sasUrlForDomainLogoUpload {
            sasUrl
            prefix
            expiresOn
          }
        }
      `
    );

    return getSasUrlForDomainLogoUpload.data;
}

export const getDeleteLinkForUserBlobUrl = async (blobUrl: string): Promise<SasDeletePayload> => {
    const getDeleteLinkForUserBlobUrl = await queryWithVariables(
        `
        query DeleteLinkForUserBlobUrl($blobUrl: String!) {
          deleteLinkForUserBlobUrl(blobUrl: $blobUrl) {
            sasUrl  ,
            expiresOn
          }
        }
      `,
        {
            blobUrl: blobUrl,
        }
    );

    return getDeleteLinkForUserBlobUrl.data.getDeleteLinkForUserBlobUrl;
};



export const getSasUrlForOrderFileUpload = async (orderId: number, orderNumber: string): Promise<SasPayload> => {
    const getSasUrlForOrderFileUpload = await queryWithVariables(
        `
        query OrderFileUploadSas($orderId: Long!, $orderNumber: String!) {
          sasUrlForOrderFileUpload(orderId: $orderId, orderNumber: $orderNumber) {
            sasUrl
            prefix
            expiresOn
            id
          }
        }
      `,
        {
            orderId: orderId,
            orderNumber: orderNumber,
        }
    );

    return getSasUrlForOrderFileUpload.data;
};

export const getDeleteLinkForOrderBlobUrl = async (blobUrl: string): Promise<SasDeletePayload> => {
    const result = await queryWithVariables(
        `
        query DeleteLinkForOrderBlobUrl($blobUrl: String!) {
          deleteLinkForOrderBlobUrl(blobUrl: $blobUrl) {
            sasUrl,
            expiresOn
          }
        }
      `,
        {
            blobUrl,
        }
    );

    return result.data.deleteLinkForOrderBlobUrl;
};
